<!--
 * @Description: 视频中心
 * @Author: zml
 * @Date: 2023-04-13 18:05:51
 * @LastEditors: zml
 * @LastEditTime: 2024-11-18 17:42:31
-->

<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'videoPage',
  mixins: [mixins],

  data() {
    return {
      componentName: ''
    }
  },
  created() {
    this.initDom()
  },
  methods: {
    initDom() {
      switch (this.$templates()) {
        case 'themeTemplateFour':
          this.componentName = 'pageVideoFour'
          break
        case 'themeTemplateSix':
          this.componentName = 'pageVideoSix'
          break
        case 'themeTemplateSeven':
          this.componentName = 'pageVideoSeven'
          break
        case 'themeTemplateEight':
          this.componentName = 'pageVideoEight'
          break
        case 'themeTemplateTen':
          this.componentName = 'pageVideoTen'
          break
        default:
          this.componentName = 'pageVideoFive'
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>